'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdShoppingBasket = function MdShoppingBasket(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 28.4c1.8 0 3.4-1.6 3.4-3.4s-1.6-3.4-3.4-3.4-3.4 1.6-3.4 3.4 1.6 3.4 3.4 3.4z m-5-13.4h10l-5-7.3z m13.7 0h7.9c1 0 1.8 0.7 1.8 1.6-1.4 5.4-2.9 10.7-4.3 16-0.4 1.4-1.7 2.4-3.2 2.4h-21.8c-1.5 0-2.8-1-3.2-2.4l-4.2-15.5c-0.1-0.1-0.1-0.3-0.1-0.5 0-0.9 0.8-1.6 1.8-1.6h7.9l7.3-10.9c0.3-0.5 0.9-0.7 1.4-0.7s1.1 0.2 1.4 0.7z' })
        )
    );
};

exports.default = MdShoppingBasket;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/shopping-basket.js
// module id = 1184
// module chunks = 0